import { render, staticRenderFns } from "./AtividadesTabela.vue?vue&type=template&id=710b0ac8"
import script from "./AtividadesTabela.vue?vue&type=script&lang=js"
export * from "./AtividadesTabela.vue?vue&type=script&lang=js"
import style0 from "./AtividadesTabela.vue?vue&type=style&index=0&id=710b0ac8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports